import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDecision } from '@optimizely/react-sdk';

import { FEATURES } from 'shared/app/components/optimizely/optimizely-keys';
import { scheduledOrderingEnabledSelector } from 'shared/app/state/selectors/ordering';
import { signedInSelector } from 'shared/app/bundles/user';

import { SET_SHOULD_SHOW_SCHEDULED_ORDERING } from 'shared/app/state/action-creators/types';

export const useScheduledOrdering = () => {
  const dispatch = useDispatch();

  const [scheduledOrderingLoading, setScheduledOrderingLoading] =
    useState(true);
  const [shouldShowScheduledOrdering, setShouldShowScheduledOrdering] =
    useState(false);

  const userSignedIn = useSelector(signedInSelector);
  const scheduledOrderingLocaleSupported = useSelector(
    scheduledOrderingEnabledSelector
  );

  const [
    scheduledOrderingDecision,
    scheduledOrderingClientReady,
    scheduledOrderingDidTimeout,
  ] = useDecision(FEATURES.SCHEDULED_ORDERING);

  const [
    scheduledOrderingGcoDecision,
    scheduledOrderingGcoClientReady,
    scheduledOrderingGcoDidTimeout,
  ] = useDecision(FEATURES.SCHEDULED_ORDERING_GCO);

  useEffect(() => {
    if (
      (scheduledOrderingClientReady && scheduledOrderingGcoClientReady) ||
      scheduledOrderingDidTimeout ||
      scheduledOrderingGcoDidTimeout
    ) {
      setScheduledOrderingLoading(false);
    }
  }, [
    scheduledOrderingClientReady,
    scheduledOrderingGcoClientReady,
    scheduledOrderingDidTimeout,
    scheduledOrderingGcoDidTimeout,
  ]);

  useEffect(() => {
    if (
      scheduledOrderingDecision?.enabled &&
      scheduledOrderingLocaleSupported
    ) {
      if (scheduledOrderingGcoDecision?.enabled || userSignedIn) {
        setShouldShowScheduledOrdering(true);
      } else {
        setShouldShowScheduledOrdering(false);
      }
    }
  }, [
    scheduledOrderingDecision,
    scheduledOrderingGcoDecision,
    scheduledOrderingLocaleSupported,
    userSignedIn,
  ]);

  useEffect(() => {
    dispatch({
      type: SET_SHOULD_SHOW_SCHEDULED_ORDERING,
      payload: shouldShowScheduledOrdering,
    });
  }, [shouldShowScheduledOrdering]);

  return { scheduledOrderingLoading, shouldShowScheduledOrdering };
};
